module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/03-c32482f8a043ce988a4e492b90eefb63.jpg";